export const minLaneWidth = 300;
export const minLaneHeight = 100;
